/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:717be2fa-4633-4377-a62c-40f2b2cfdbc0",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_o7SV8aqAe",
    "aws_user_pools_web_client_id": "48spfc670tjikb095gvdfbnbhn",
    "oauth": {
        "domain": "midwayauth-ispdevamp.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://preprod-isp-revoke-purchase.alexa.amazon.dev/",
        "redirectSignOut": "http://localhost:3000/,https://preprod-isp-revoke-purchase.alexa.amazon.dev/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
